import React from "react";
import { Button } from "react-bootstrap";
import '.././assets/css/delete.css';

export const DeleteModal = ({ isOpen, onClose, onConfirmDelete, isDeleteDisabled, modalTitle = "Discard Changes", modalBody }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal fade discard_modal show"
      id="delete-model"
      style={{ display: "block" }}
      aria-hidden={!isOpen}
      aria-labelledby="deleteModalLabel"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <p className="modal-title" id="deleteModalLabel">
              {modalTitle}
            </p>
          </div>
          <div className="modal-body">
            {modalBody ? (
              modalBody
            ) : (
              <>
                <p className="modal-msg-title">Delete</p>
                <p className="modal-msg-desc">
                  Are you sure you want to Delete?
                </p>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              className="btn btn_light__red mx-2"
              onClick={onClose}
              disabled={isDeleteDisabled}
            >
              Cancel
            </button>

            <Button
              data-testid="deleteButton"
              className={`btn btn_red btn-loader ${isDeleteDisabled ? "btn_red_disabled" : ""}`}
              onClick={onConfirmDelete}
              disabled={isDeleteDisabled}
            >
              {isDeleteDisabled ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};